import React from "react";
import config from "../data/siteConfig";
import { featured } from "../data/gallery";
import { ArchImage, MandalaCorner, Elephant, Ornament } from "./Decor";
import { GiCutDiamond } from "react-icons/gi";

export default function About() {
  return (
    <section id="about" className="relative overflow-hidden py-20 md:py-28">
      <MandalaCorner className="absolute -left-6 top-10 h-40 w-40 text-coffee-300/40" />
      <Elephant className="absolute bottom-8 right-6 hidden h-28 w-32 text-coffee-300/40 lg:block" />

      <div className="container-x grid items-center gap-14 md:grid-cols-2">
        {/* images */}
        <div className="reveal relative">
          <div className="grid grid-cols-2 gap-4">
            <ArchImage src={featured[1]} alt="Heritage gold necklace" className="mt-10" imgClass="aspect-[3/4]" />
            <ArchImage src={featured[3]} alt="Bridal jewellery set" imgClass="aspect-[3/4]" />
          </div>
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 flex h-28 w-28 flex-col items-center justify-center rounded-full border-2 border-gold bg-coffee-grad text-center text-gold-light shadow-vintage">
            <b className="font-display text-2xl leading-none">916</b>
            <span className="mt-1 text-[0.55rem] uppercase tracking-[0.2em]">Hallmark Gold</span>
          </div>
        </div>

        {/* text */}
        <div className="reveal">
          <span className="eyebrow">Our Heritage</span>
          <h2 className="mt-2 font-display text-3xl text-coffee-800 sm:text-4xl">
            A Legacy of Kutchi Goldsmithing
          </h2>
          <div className="mt-4"><Ornament className="!justify-start" /></div>

          <p className="mt-6 text-coffee-700/90">
            Rooted in the cultural soil of Bhuj and Kutch, <strong className="text-coffee-900">{config.brand.name}</strong>{" "}
            — the house of <em className="gu">{config.brand.houseGu}</em> — has been adorning families of Bhachau with
            authentic gold ornaments for generations.
          </p>
          <p className="mt-4 text-coffee-700/90">
            Every piece reflects the timeless artistry of Kutchi craftsmanship: intricate filigree,
            traditional kundan-meena work, and bridal sets designed to be treasured and passed down.
            Hallmarked, honestly weighed and fairly priced.
          </p>

          <div className="mt-6 grid grid-cols-2 gap-3">
            {["Bridal Specialists", "BIS Hallmark 916", "Custom Designs", "Fair Daily Rates"].map((t) => (
              <div key={t} className="flex items-center gap-2 rounded-md border border-gold/30 bg-cream/60 px-4 py-2.5 text-sm text-coffee-700">
                <GiCutDiamond className="shrink-0 text-gold-deep" /> {t}
              </div>
            ))}
          </div>

          <p className="gu mt-6 font-serif text-xl italic text-maroon">
            — {config.brand.nameGu} (આઘોઈવાળા)
          </p>
          <a className="btn btn-coffee mt-6" href="#collections">Discover Our Collections</a>
        </div>
      </div>
    </section>
  );
}
